import React from "react";
import { FieldArray, useFormikContext } from "formik";
import styles from "./style.module.scss";
import TextInput from "../../../../../../../components/form/text-input";
import FancyRadio from "../../../../../../../components/form/fancy-radio-input";
import Select from "../../../../../../../components/form/select";
import Button from "../../../../../../../components/new-button";
import PlusIcon from "../../../../../../../assets/svg/icons/common/Plus";
import TrashIcon from "../../../../../../../assets/svg/icons/common/Trash";

const AUDIENCE_OPTIONS = ["B2B", "B2C", "Both", "Medical Professionals"];
const AGE_VERIFICATION_OPTIONS = [
  { value: "Website/on line verification", label: "Website/on line verification" },
  { value: "Government issued photo ID", label: "Government issued photo ID" },
  { value: "Third party verification (specify)", label: "Third party verification (specify)" },
  { value: "Other", label: "Other" },
];
const MAX_PRODUCT_TYPES = 18;

function VapeAttestation() {
  const {
    values, errors, touched,
    handleChange, handleBlur, setFieldValue,
  } = useFormikContext();

  const textField = (name, label, placeholder = label) => (
    <TextInput
      label={label}
      placeholder={placeholder}
      type="text"
      id={name}
      name={name}
      value={values[name] ?? ""}
      onChange={handleChange}
      onBlur={handleBlur}
      touched={touched[name]}
      errored={errors[name]}
      error={errors[name]}
    />
  );

  return (
    <div className={styles.container}>
      <h4 className={styles.sectionTitle}>Kurv - Vape Attestation</h4>

      <div className={styles.formGroup}>
        {textField(
          "vape_attestation_what_is_your_source_of_marketing",
          "What is your source of marketing?",
          "Select Source of Marketing",
        )}
      </div>

      <div className={styles.radioBlock}>
        <p className={styles.subtitle}>What audience is the product marketed to?</p>
        <div className={styles.radioRow}>
          {AUDIENCE_OPTIONS.map((option) => (
            <FancyRadio
              key={option}
              label={option}
              name="vape_attestation_what_audience_is_the_product_marketed_to"
              id={`vape_audience_${option}`}
              checked={values.vape_attestation_what_audience_is_the_product_marketed_to === option}
              onChange={() => setFieldValue("vape_attestation_what_audience_is_the_product_marketed_to", option)}
              onBlur={handleBlur}
              touched={touched.vape_attestation_what_audience_is_the_product_marketed_to}
              errored={errors.vape_attestation_what_audience_is_the_product_marketed_to}
              error={errors.vape_attestation_what_audience_is_the_product_marketed_to}
            />
          ))}
        </div>
        {touched.vape_attestation_what_audience_is_the_product_marketed_to &&
          errors.vape_attestation_what_audience_is_the_product_marketed_to && (
            <div className={styles.error}>
              {errors.vape_attestation_what_audience_is_the_product_marketed_to}
            </div>
          )}
      </div>

      <div className={styles.productsBlock}>
        <p className={styles.subtitle}>List the names of the top 5 selling products</p>
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className={styles.formGroup}>
            {textField(`vape_attestation_product_${i}`, `Product ${i}`, `Product ${i}`)}
          </div>
        ))}
      </div>

      <div className={styles.formGroup}>
        <p className={styles.subtitle}>Where are the products manufactured?</p>
        {textField("where_are_the_products_manufactured", "Name, address, Phone number")}
      </div>

      <div className={styles.productsBlock}>
        <p className={styles.subtitle}>
          List the product types being sold (E-liquids, e-cigarettes, vape products, Cigarettes, Cigars, Shisha, Devices, etc.)
        </p>
        <FieldArray name="vape_attestation_product_types">
          {({ push, remove }) => (
            <>
              {values.vape_attestation_product_types?.map((_, index) => (
                <div key={index} className={styles.productTypeRow}>
                  <div className={styles.productTypeInput}>
                    <TextInput
                      label="Product Type"
                      placeholder="Product Type"
                      type="text"
                      id={`vape_attestation_product_types.${index}.name`}
                      name={`vape_attestation_product_types.${index}.name`}
                      value={values.vape_attestation_product_types[index].name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched?.vape_attestation_product_types?.[index]?.name}
                      errored={errors?.vape_attestation_product_types?.[index]?.name}
                      error={errors?.vape_attestation_product_types?.[index]?.name}
                    />
                  </div>
                  {index > 0 && (
                    <Button
                      variant="ghost"
                      size="small"
                      type="button"
                      icon={<TrashIcon color="#3A383F" />}
                      onClick={() => remove(index)}
                    />
                  )}
                </div>
              ))}
              {values.vape_attestation_product_types?.length < MAX_PRODUCT_TYPES && (
                <Button
                  variant="ghost"
                  type="button"
                  icon={<PlusIcon color="#4C70EF" />}
                  onClick={() => push({ name: "" })}
                >
                  Add Product Type
                </Button>
              )}
            </>
          )}
        </FieldArray>
      </div>

      <div className={styles.formGroup}>
        <Select
          label="What method of age verification is used?"
          placeholder="Select Method of Age Verification"
          id="vape_attestation_method_of_age_verification"
          name="vape_attestation_method_of_age_verification"
          options={AGE_VERIFICATION_OPTIONS}
          value={values.vape_attestation_method_of_age_verification}
          onChange={(value) => setFieldValue("vape_attestation_method_of_age_verification", value)}
          onBlur={handleBlur}
          touched={touched.vape_attestation_method_of_age_verification}
          errored={errors.vape_attestation_method_of_age_verification}
          error={errors.vape_attestation_method_of_age_verification}
          search
        />
      </div>

      {values.vape_attestation_method_of_age_verification === "Other" && (
        <div className={styles.formGroup}>
          {textField("vape_attestation_other_method_of_age_verification", "Other Method of Age Verification")}
        </div>
      )}
    </div>
  );
}

export default VapeAttestation;
